// ProfileMenu.js
import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import withRouter from "components/Common/withRouter";
import PropTypes from 'prop-types';
import { Link, useNavigate } from "react-router-dom";

import { selectUserData, selectResources } from "../../../store/selectors";

//i18n
import { withTranslation } from "react-i18next";

// Redux
import { connect } from "react-redux";
import { useSelector, useDispatch } from "react-redux";
import { 
  loadDatabaseImages, 
  loadBaseDbImages,
  loadProjectImages,
  loadAgentImages,
  loadChatbotImages,
  loadProductImages,
} from "store/actions";

// Custom Utils
import { fetchImage } from 'utils/imageUtils';
// Image
import placeholder from "assets/images/placeholders/placeholder_card.png"

// Top Bar Profile Dropdown Menu
const ProfileMenu = props => {

  const { matches, matches1, matches2 } = props;

  /*---- Initial Setup ----*/

  const [menu, setMenu] = useState(false);
  const [profilePic, SetProfilePic] = useState(placeholder);
  const [username, setUsername] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  /*---- Initial Setup Tail ----*/



  /*---- User Data ----*/

  const { userData, tokenNotFound } = useSelector(selectUserData);

  const fetchAndSetProfilePic = async () => {
    const newProfilePic = await fetchImage(userData.profileImg);
    SetProfilePic(newProfilePic);
  };

  useEffect(() => {

    if(!Object.keys(userData).length){ 
      console.log('[src/components/.../ProfileMenu.js] fetching user data...');
      dispatch({ type: 'FETCH_USER_DATA' }); 
    } else {
      if(Object.keys(userData).length){
        console.log('[src/components/.../ProfileMenu.js] userData:', userData);
        if(userData.username){setUsername(userData.username);}
        if(userData.profileImg){fetchAndSetProfilePic();}
        sessionStorage.removeItem("isRedirectedToLogin");
      }
    }

  }, [userData]);

  /*---- User Data Tail ----*/



  /*---- Token Not Found ----*/

  useEffect(() => {
    if (tokenNotFound) {
      localStorage.removeItem('authUser');
      navigate('/login');
    }
  }, [tokenNotFound, navigate]);

  /*---- Token Not Found Tail ----*/



  /*---- Retrieving Databases, Projects, and Chatbots Images Tail ----*/
  useEffect(()=>{
    console.log('matches changed:', matches);
  }, [JSON.stringify(matches), JSON.stringify(matches1), JSON.stringify(matches2)]);

  return (

    <React.Fragment>

      <UncontrolledDropdown className="d-inline-block" style={{ minWidth: "50px" }}>

        <DropdownToggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button"
          style={{ padding:'12px 3px 7px 3px' }}
        >
          <img
            className="rounded-circle header-profile-user"
            src={profilePic || placeholder}
            style={{ objectFit: "cover", marginTop: "-4px" }}
          />
          <span className="d-xl-inline-block ms-2 me-1">
            {!username ?(
              <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            ):(
              <>
                {(!matches && !matches1) && (
                  <div className="d-inline-block">
                    {username.length>5 ? username.slice(0, 5)+'...' : username}
                  </div>
                )}
                {(matches || matches1) && (
                  <div className="d-inline-block">
                    {username.length>4 ? username : username}
                  </div>
                )}
              </>
            )}
          </span>
          <i className="mdi mdi-chevron-down d-xl-inline-block" />
        </DropdownToggle>

        {/* Action Menu */}
        <DropdownMenu className="dropdown-menu-end">

          {/* 帳號資訊 in Profile Dropdown Menu */}
          <Link to="/profile" className="dropdown-item">
            <i className="bx bx-user font-size-16 align-middle me-1" />
            <span>{props.t("帳號資訊")}</span>
          </Link>

          <div className="dropdown-divider" />

          {/* 登出 in Profile Dropdown Menu */}
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("登出")}</span>
          </Link>

          {/*
          <Link to="/crypto-wallet" className="dropdown-item">
            <i className="bx bx-wallet font-size-16 align-middle me-1" />
            {props.t("My Wallet")}
          </Link>
          */}

          {/*
          <Link to="/setting" className="dropdown-item">
            <span className="badge bg-success float-end">11</span>
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            <span>{props.t("Settings")}</span>
          </Link>
          */}

          {/*
          <Link to="/auth-lock-screen" className="dropdown-item">
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            <span>{props.t("Lock screen")}</span>
          </Link>
          */}
          
        </DropdownMenu>
        {/* Action Menu Tail */}

      </UncontrolledDropdown>

    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
